module.exports = __webpack_public_path__ + "html/title-block_0943c583757a6eb44ac3542962443093.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/title-block.html
// module id = GnEM
// module chunks = 74